import styled from 'styled-components';
import { color } from '../../../atoms/colors';
import { font } from '../../../atoms/typography';
import { atMinWidth } from '../../../atoms/breakpoints';
import {
  defaultStyles,
  variants,
  sizes,
} from '../../CallToAction/styles/theme.styled';
import { spacing } from '../../../atoms/spacing';

export const Modal = styled.dialog`
  position: fixed;
  inset: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  z-index: 10000;
  background: transparent;
  overflow-y: scroll;
  opacity: 0;
  pointer-events: none;
  transition: all 300ms ease-in-out;
  &.modal-active {
    opacity: 1;
    pointer-events: all;
  }
`;

export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  background: rgba(0, 43, 71, 0.9);
  backdrop-filter: blur(4px);
  outline: none;
  border: none;
  padding: 0px 16px;
`;

export const Container = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  max-width: 488px;
  padding: 32px 40px;
  flex-direction: column;
  align-items: flex-end;
  gap: 48px;
  align-self: stretch;
  border-radius: 16px;
  background-color: ${color.common.white};
  border-top: 7px solid #007bff;
  margin: auto;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  align-self: stretch;
`;

export const ApprovalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

export const ErrorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  margin-top: 40px;
`;

export const Heading = styled.h2`
  ${font('display', 'sm', '500')}
  color: ${props =>
    props.theme === 'steel' ? color.blue[700] : color.darkBlue[1000]};
`;

export const ErrorHeading = styled.h2`
  ${font('display', 'md', '500')}
  color: ${color.darkBlue[1000]};
  text-align: center;
`;

export const Subhead = styled.p`
  ${font('text', 'xl', '700')}
  color: ${color.darkBlue[1000]};
`;

export const Description = styled.p`
  ${font('text', 'md', '400')}
  color: ${color.darkBlue[600]};
  text-align: ${props => (props.align ? 'center' : 'left')};
`;

export const Form = styled.form`
  display: flex;
  gap: 6px;
`;

export const Input = styled.input`
  height: 40px;
  width: 40px;
  padding: 8px;
  border-radius: 8px;
  border: 2px solid ${color.blue[700]};
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  ${font('display', 'md', '600')}
  text-align: center;

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  -moz-appearance: textfield;
  ${atMinWidth.sm`
    height: 60px;
    width: 60px;
  `}
`;

export const Button = styled.button`
  ${defaultStyles}
  ${props =>
    props.theme === 'steel'
      ? variants['Filled - Blue']
      : variants['Filled - Dark']}
  ${sizes.lg}
`;

export const ResendCodeButton = styled.button`
  display: flex;
  gap: ${spacing[8]};
  padding: ${spacing[6]} ${spacing[12]} ${spacing[6]} ${spacing[0]};
  outline: none;
  border: none;
  background: ${color.common.transparent};
  border-radius: 8px;
  width: max-content;
  transition: all 250ms ease-in-out;
  ${font('text', 'md', '500')}
  color: ${color.darkBlue[700]};
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  width: 100%;
`;

export const SupportText = styled.p`
  ${font('text', 'sm', '400')}
  color: ${color.darkBlue[600]};
`;

export const ErrorMessage = styled.p`
  ${font('display', 'xs', '600')}
  color: ${color.darkBlue[600]};
  text-align: center;
`;

export const Emoji = styled.span`
  font-size: 60px;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 24px;
  height: 24px;
  width: 24px;
  background: ${color.common.transparent};
  outline: none;
  border: none;
  use {
    height: 24px;
    width: 24px;
  }
`;
